export function Technologies() {
  return (
    <div className="flex flex-col justify-center w-1/5 items-center">
      <div className="flex flex-col justify-evenly items-center text-center font-bold m-4 p-2 w-28 lg:w-40 bg-tdgray rounded-xl">
        <img src="./assets/react.png" alt="React" className="w-16 h-16 lg:w-32 lg:h-32" />
        <p>React</p>
      </div>
      <div className="flex flex-col justify-evenly items-center text-center font-bold m-4 p-2 w-28 lg:w-40 bg-tgray rounded-xl">
        <img src="./assets/tailwind.png" alt="Tailwind CSS" className="object-contain w-16 h-16 lg:w-32 lg:h-32" />
        <p>Tailwind</p>
      </div>
      <div className="flex flex-col justify-evenly items-center text-center font-bold m-4 p-2 w-28 lg:w-40 bg-tdgray rounded-xl">
        <img src="./assets/node-js.png" alt="Node.js" className="w-16 h-16 lg:w-32 lg:h-32" />
        <p>Node.js</p>
      </div>
      <div className="flex flex-col justify-evenly items-center text-center font-bold m-4 p-2 w-28 lg:w-40 bg-tgray rounded-xl">
        <img src="./assets/css3.png" alt="CSS 3" className="w-16 h-16 lg:w-32 lg:h-32" />
        <p>CSS 3</p>
      </div>
      <div className="flex flex-col justify-evenly items-center text-center font-bold m-4 p-2 w-28 lg:w-40 bg-tdgray rounded-xl">
        <img src="./assets/html.png" alt="HTML 5" className="w-16 h-16 lg:w-32 lg:h-32" />
        <p>HTML 5</p>
      </div>
      <div className="flex flex-col justify-evenly items-center text-center font-bold m-4 p-2 w-28 lg:w-40 bg-tgray rounded-xl">
        <img src="./assets/typescript.png" alt="Typescript" className="w-16 h-16 lg:w-32 lg:h-32" />
        <p>Typescript</p>
      </div>
      <div className="flex flex-col justify-evenly items-center text-center font-bold m-4 p-2 w-28 lg:w-40 bg-tdgray rounded-xl">
        <img src="./assets/express.png" alt="Express" className="w-16 h-16 lg:w-32 lg:h-32" />
        <p>Express</p>
      </div>
      <div className="flex flex-col justify-evenly items-center text-center font-bold m-2 p-2 w-28 lg:w-40 bg-tgray rounded-xl">
        <img src="./assets/knex.png" alt="Knex" className="w-16 h-16 lg:w-32 lg:h-32" />
        <p>Knex</p>
      </div>
      <div className="flex flex-col justify-evenly items-center text-center font-bold m-4 p-2 w-28 lg:w-40 bg-tdgray rounded-xl">
        <img src="./assets/postgresql.png" alt="PostGreSQL" className="w-16 h-16 lg:w-32 lg:h-32" />
        <p>PostGreSQL</p>
      </div>
    </div>
  );
}
